module.exports = __webpack_public_path__ + "8a2646548.png";